<!-- visitor/src/components/V2/shell/Shell.vue -->
<template>
    <div class="sps-shell" :class="{ 'is-legacy': !enabled }">
        <div class="sps-shell__view">
            <Launcher v-if="!enabled || chatOpen" v-bind="$attrs" v-on="$listeners">
                <template v-for="(_, name) in $scopedSlots" v-slot:[name]="scope"><slot :name="name" v-bind="scope" /></template>
            </Launcher>
            <HomeView v-else-if="activeTab === 'home'" @ask="ask" @open-article="openArticle" />
            <MessagesView v-else-if="activeTab === 'messages'" :colors="$attrs.colors" @ask="ask" @open-chat="openChat" />
            <HelpView v-else-if="activeTab === 'help'" :colors="$attrs.colors" @ask="ask" />
        </div>
        <TabBar v-if="showTabBar" :tabs="tabs" :active="activeTab" :unread="unreadCount" @select="openTab" />
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { filter } from "rxjs/operators";
import Launcher from "../popup-chat/Launcher.vue";
import TabBar from "./TabBar.vue";
import HomeView from "./HomeView.vue";
import MessagesView from "./MessagesView.vue";
import HelpView from "./HelpView.vue";
import { parentWindowMessageStream } from "../../../utils/parentWindowConnection";
import { pickNewIncoming, absorbKeys } from "../../../utils/shell/newMessages";
import { writeUrlState } from "../../../utils/shell/urlState";
import { log2 } from "../../../utils/log2";
const log = log2("Shell");
// Bu komutlar dogrudan sohbeti acar; Home atlanir (tetikleyici, SDK, otomatik giris)
const DIRECT_CHAT_COMMANDS = ["trigger-start-chat", "trigger-open-chat", "auto-login", "set-chatbot-start-block-id"];
export default {
    name: "Shell",
    inheritAttrs: false,
    components: { Launcher, TabBar, HomeView, MessagesView, HelpView },
    computed: {
        ...mapState({ activeTab: (s) => s.shell.activeTab, chatOpen: (s) => s.shell.chatOpen }),
        ...mapGetters({ enabled: "shell/enabled", tabs: "shell/tabs", unreadCount: "shell/unreadCount", showTabBar: "shell/showTabBar" }),
        navState() {
            const s = this.$store.state;
            return { write: this.enabled && s.shell.booted && !s.app.previewMode, tab: this.activeTab, chat: this.chatOpen };
        },
    },
    methods: {
        ...mapActions({ boot: "shell/boot", openTab: "shell/openTab", openChat: "shell/openChat" }),
        ask() { this.openChat(); this.$root.$emit("focusUserInput"); },
        // Makaleyi Catalog kendi gezinme yolundan acar; boylece geri butonu calisir
        openArticle(a) {
            this.$store.dispatch("shell/setPendingArticle", { _id: a._id, collectionId: a.collectionId, slug: a.slug, name: a.title });
            this.openTab("help");
        },
    },
    created() {
        // Reaktif olmasina gerek yok: yalnizca "bu mesaji gordum" kaydi
        this.seenKeys = absorbKeys(this.$attrs.messageList, new Set());
        this.boot();
        this.subs = [
            parentWindowMessageStream.pipe(filter((q) => DIRECT_CHAT_COMMANDS.includes(q.command))).subscribe((q) => { log("direct chat", q.command); this.openChat(); }),
            parentWindowMessageStream.pipe(filter((q) => q.command === "iframe-open")).subscribe(() => { if (!this.$store.state.shell.booted) this.boot(); }),
        ];
    },
    watch: {
        // Acik sekme ve sohbet adrese yazilir; Yardim disina cikinca koleksiyon/makale silinir. Onizlemede ve eski widget'ta yazilmaz
        navState(v) {
            if (!v.write) return;
            writeUrlState(v.tab === "help" && !v.chat ? { tab: v.tab, chat: false } : { tab: v.tab, chat: v.chat, collection: null, article: null });
        },
        // Daha once gorulmemis karsi-taraf mesaji sohbete dusurur; gecmis yuklemesi (loadOldMessages) tetiklemez
        "$attrs.messageList": function (next, prev) {
            const list = next || [];
            // Bos listenin ilk dolusu gecmis yuklemesidir (loadOldMessages); tumu gorulmus sayilir, sohbet acilmaz
            if (!(prev || []).length && list.length) { absorbKeys(list, this.seenKeys); return; }
            const fresh = pickNewIncoming(list, this.seenKeys);
            absorbKeys(list, this.seenKeys);
            if (!this.enabled) return;
            const conversationId = this.$store.state.chat.conversationId;
            if (this.chatOpen) { if (conversationId) this.$store.dispatch("shell/markRead", conversationId); return; }
            if (fresh.length && this.$store.state.shell.booted) this.openChat();
        },
        // Ayarlar sunucudan gelince boot yeniden calisir (booted guard'i erken donusu engeller)
        "$store.state.setting.fetched": function (v) { if (v) this.boot(); },
    },
    beforeDestroy() { (this.subs || []).forEach((s) => s.unsubscribe()); },
};
</script>
<style lang="scss">
.sps-shell { display: flex; flex-direction: column; height: 100vh; height: 100dvh; &__view { flex: 1; min-height: 0; > * { height: 100%; } } }
</style>



// WEBPACK FOOTER //
// src/components/V2/shell/Shell.vue